<template>
    <div class="token-offerings">
        <carousel :navigationEnabled="true"
            navigation-next-label=""
            navigation-prev-label=""
            :paginationEnabled="false"
            :scrollPerPage="false"
            :perPageCustom="[
                [320, 1.3],
                [400, 1.7],
                [450, 1.8],
                [525, 2.2],
                [600, 2.5],
                [768, 1.8],
                [900, 2.2],
                [1000, 2.5],
                [1150, 3.5],
                [1300, 3.5],
                [1400, 4],
                [1500, 4.5],
                [1600, 5],
                [1800, 6]
            ]"
        >
            <slide v-for="(tokenOffering, index) of ids"
                :key="index"
            >
                <token-offering-tile :id="`token-tile-${index}`"
                    :token-offering-id="tokenOffering"
                />
            </slide>
        </carousel>
    </div>
</template>

<script>
import tokenOfferingTile from '@webapp/components/token-tiles/token-offering-tile.vue';

// Components
import {
    Carousel,
    Slide,
} from 'vue-carousel';

export default {
    name: 'token-offerings',
    components: {
        tokenOfferingTile,
        Carousel,
        Slide,
    },
    props: {
        ids: {
            type: Array,
            default: () => [],
        },
    },
};
</script>